import type { GameResponse } from '@warcarp/api-types'

export const PRACTICE_GAME_CLASSIFICATION = { isPublic: false, isRanked: false } as const

/** Never resume an older ranked tutorial as the new unranked practice match. */
export function isResumablePracticeGame(game: Pick<GameResponse, 'name' | 'mapId' | 'status' | 'isRanked'>): boolean {
  return game.name === 'WarCarp Tutorial' && game.mapId === 'carpathia' &&
    game.isRanked === false && game.status !== 'COMPLETE' && game.status !== 'ABANDONED'
}

export const TUTORIAL_WELCOME_KEY = (userId: string) => `tutorial-welcome-seen_${userId}`

/** Per-game, per-device opt-in state for contextual in-game tutorial help. */
export const TUTORIAL_MODE_KEY = (gameId: string) => `tutorial-mode_${gameId}`
/** Legacy web keys used a colon, which SecureStore rejects on native. */
export const LEGACY_WEB_TUTORIAL_MODE_KEY = (gameId: string) => `tutorial-mode:${gameId}`
